export const IndianStates = [
  { id: "AN", label: "Andaman and Nicobar Islands", value: "AN" },
  { id: "AP", label: "Andhra Pradesh", value: "AP" },
  { id: "AR", label: "Arunachal Pradesh", value: "AR" },
  { id: "AS", label: "Assam", value: "AS" },
  { id: "BR", label: "Bihar", value: "BR" },
  { id: "CH", label: "Chandigarh", value: "CH" },
  { id: "CT", label: "Chhattisgarh", value: "CT" },
  { id: "DN", label: "Dadra and Nagar Haveli and Daman and Diu", value: "DN" },
  { id: "DL", label: "Delhi", value: "DL" },
  { id: "GA", label: "Goa", value: "GA" },
  { id: "GJ", label: "Gujarat", value: "GJ" },
  { id: "HR", label: "Haryana", value: "HR" },
  { id: "HP", label: "Himachal Pradesh", value: "HP" },
  { id: "JK", label: "Jammu and Kashmir", value: "JK" },
  { id: "JH", label: "Jharkhand", value: "JH" },
  { id: "KA", label: "Karnataka", value: "KA" },
  { id: "KL", label: "Kerala", value: "KL" },
  { id: "LA", label: "Ladakh", value: "LA" },
  { id: "LD", label: "Lakshadweep", value: "LD" },
  { id: "MP", label: "Madhya Pradesh", value: "MP" },
  { id: "MH", label: "Maharashtra", value: "MH" },
  { id: "MN", label: "Manipur", value: "MN" },
  { id: "ML", label: "Meghalaya", value: "ML" },
  { id: "MZ", label: "Mizoram", value: "MZ" },
  { id: "NL", label: "Nagaland", value: "NL" },
  { id: "OR", label: "Odisha", value: "OR" },
  { id: "PY", label: "Puducherry", value: "PY" },
  { id: "PB", label: "Punjab", value: "PB" },
  { id: "RJ", label: "Rajasthan", value: "RJ" },
  { id: "SK", label: "Sikkim", value: "SK" },
  { id: "TN", label: "Tamil Nadu", value: "TN" },
  { id: "TS", label: "Telangana", value: "TS" },
  { id: "TR", label: "Tripura", value: "TR" },
  { id: "UP", label: "Uttar Pradesh", value: "UP" },
  { id: "UK", label: "Uttarakhand", value: "UK" },
  { id: "WB", label: "West Bengal", value: "WB" },
];

export const SkillArr = [
  {
    id: 1,
    label: "Property Case",
    value: 1,
  },
  {
    id: 3,
    label: "Divorce Case",
    value: 3,
  },
  {
    id: 4,
    label: "Property Mediation",
    value: 4,
  },
  {
    id: 2,
    label: "Crime Case",
    value: 2,
  },
  {
    id: 5,
    label: "Divorce Mediation",
    value: 5,
  },
  {
    id: 8,
    label: "Crime Mediation",
    value: 8,
  },
  {
    id: 6,
    label: "CA Work",
    value: 6,
  },
  {
    id: 7,
    label: "CS Work",
    value: 7,
  },
];

export const RolesArr = [
  {
    id: "LAWYER",
    label: "LAWYER",
    value: "LAWYER",
  },
  {
    id: "MEDIATOR",
    label: "MEDIATOR",
    value: "MEDIATOR",
  },
  {
    id: "CA",
    label: "CA",
    value: "CA",
  },
  {
    id: "CS",
    label: "CS",
    value: "CS",
  },
  {
    id: "OTHERS",
    label: "OTHERS",
    value: "OTHERS",
  },
];

export const OrgDropArr = [
  {
    id: 1,
    label: "HDFC Bank",
    value: 1,
  },
];

// City data structure
export interface CityOption {
  id: string;
  label: string;
  value: string;
  stateCode: string;
}

// Comprehensive Indian cities data organized by state codes
export const IndianCities: CityOption[] = [
  // Maharashtra (MH)
  { id: "MH_MUM", label: "Mumbai", value: "Mumbai", stateCode: "MH" },
  { id: "MH_PUN", label: "Pune", value: "Pune", stateCode: "MH" },
  { id: "MH_NAG", label: "Nagpur", value: "Nagpur", stateCode: "MH" },
  { id: "MH_NAS", label: "Nashik", value: "Nashik", stateCode: "MH" },
  { id: "MH_AUR", label: "Aurangabad", value: "Aurangabad", stateCode: "MH" },
  { id: "MH_SOL", label: "Solapur", value: "Solapur", stateCode: "MH" },
  { id: "MH_KOL", label: "Kolhapur", value: "Kolhapur", stateCode: "MH" },
  { id: "MH_AMR", label: "Amravati", value: "Amravati", stateCode: "MH" },

  // Karnataka (KA)
  { id: "KA_BLR", label: "Bangalore", value: "Bangalore", stateCode: "KA" },
  { id: "KA_MYS", label: "Mysore", value: "Mysore", stateCode: "KA" },
  { id: "KA_HUB", label: "Hubli", value: "Hubli", stateCode: "KA" },
  { id: "KA_MAN", label: "Mangalore", value: "Mangalore", stateCode: "KA" },
  { id: "KA_BEL", label: "Belgaum", value: "Belgaum", stateCode: "KA" },
  { id: "KA_GUL", label: "Gulbarga", value: "Gulbarga", stateCode: "KA" },
  { id: "KA_DAV", label: "Davangere", value: "Davangere", stateCode: "KA" },
  { id: "KA_BIJ", label: "Bijapur", value: "Bijapur", stateCode: "KA" },

  // Delhi (DL)
  { id: "DL_NEW", label: "New Delhi", value: "New Delhi", stateCode: "DL" },
  { id: "DL_CEN", label: "Central Delhi", value: "Central Delhi", stateCode: "DL" },
  { id: "DL_NOR", label: "North Delhi", value: "North Delhi", stateCode: "DL" },
  { id: "DL_SOU", label: "South Delhi", value: "South Delhi", stateCode: "DL" },
  { id: "DL_EAS", label: "East Delhi", value: "East Delhi", stateCode: "DL" },
  { id: "DL_WES", label: "West Delhi", value: "West Delhi", stateCode: "DL" },

  // Tamil Nadu (TN)
  { id: "TN_CHE", label: "Chennai", value: "Chennai", stateCode: "TN" },
  { id: "TN_COI", label: "Coimbatore", value: "Coimbatore", stateCode: "TN" },
  { id: "TN_MAD", label: "Madurai", value: "Madurai", stateCode: "TN" },
  { id: "TN_TIR", label: "Tiruchirappalli", value: "Tiruchirappalli", stateCode: "TN" },
  { id: "TN_SAL", label: "Salem", value: "Salem", stateCode: "TN" },
  { id: "TN_TIR2", label: "Tirunelveli", value: "Tirunelveli", stateCode: "TN" },
  { id: "TN_ERO", label: "Erode", value: "Erode", stateCode: "TN" },
  { id: "TN_VEL", label: "Vellore", value: "Vellore", stateCode: "TN" },

  // Gujarat (GJ)
  { id: "GJ_AHM", label: "Ahmedabad", value: "Ahmedabad", stateCode: "GJ" },
  { id: "GJ_SUR", label: "Surat", value: "Surat", stateCode: "GJ" },
  { id: "GJ_VAD", label: "Vadodara", value: "Vadodara", stateCode: "GJ" },
  { id: "GJ_RAJ", label: "Rajkot", value: "Rajkot", stateCode: "GJ" },
  { id: "GJ_BHA", label: "Bhavnagar", value: "Bhavnagar", stateCode: "GJ" },
  { id: "GJ_JUN", label: "Junagadh", value: "Junagadh", stateCode: "GJ" },
  { id: "GJ_JAM", label: "Jamnagar", value: "Jamnagar", stateCode: "GJ" },
  { id: "GJ_GAN", label: "Gandhinagar", value: "Gandhinagar", stateCode: "GJ" },

  // Uttar Pradesh (UP)
  { id: "UP_LUC", label: "Lucknow", value: "Lucknow", stateCode: "UP" },
  { id: "UP_KAN", label: "Kanpur", value: "Kanpur", stateCode: "UP" },
  { id: "UP_AGR", label: "Agra", value: "Agra", stateCode: "UP" },
  { id: "UP_VAR", label: "Varanasi", value: "Varanasi", stateCode: "UP" },
  { id: "UP_ALL", label: "Allahabad", value: "Allahabad", stateCode: "UP" },
  { id: "UP_MEE", label: "Meerut", value: "Meerut", stateCode: "UP" },
  { id: "UP_GHA", label: "Ghaziabad", value: "Ghaziabad", stateCode: "UP" },
  { id: "UP_NOI", label: "Noida", value: "Noida", stateCode: "UP" },

  // West Bengal (WB)
  { id: "WB_KOL", label: "Kolkata", value: "Kolkata", stateCode: "WB" },
  { id: "WB_HOW", label: "Howrah", value: "Howrah", stateCode: "WB" },
  { id: "WB_DUR", label: "Durgapur", value: "Durgapur", stateCode: "WB" },
  { id: "WB_ASA", label: "Asansol", value: "Asansol", stateCode: "WB" },
  { id: "WB_SIL", label: "Siliguri", value: "Siliguri", stateCode: "WB" },
  { id: "WB_BAR", label: "Barrackpore", value: "Barrackpore", stateCode: "WB" },

  // Rajasthan (RJ)
  { id: "RJ_JAI", label: "Jaipur", value: "Jaipur", stateCode: "RJ" },
  { id: "RJ_JOD", label: "Jodhpur", value: "Jodhpur", stateCode: "RJ" },
  { id: "RJ_UDA", label: "Udaipur", value: "Udaipur", stateCode: "RJ" },
  { id: "RJ_KOT", label: "Kota", value: "Kota", stateCode: "RJ" },
  { id: "RJ_BIK", label: "Bikaner", value: "Bikaner", stateCode: "RJ" },
  { id: "RJ_AJM", label: "Ajmer", value: "Ajmer", stateCode: "RJ" },

  // Haryana (HR)
  { id: "HR_GUR", label: "Gurgaon", value: "Gurgaon", stateCode: "HR" },
  { id: "HR_FAR", label: "Faridabad", value: "Faridabad", stateCode: "HR" },
  { id: "HR_PAN", label: "Panipat", value: "Panipat", stateCode: "HR" },
  { id: "HR_AMB", label: "Ambala", value: "Ambala", stateCode: "HR" },
  { id: "HR_HIR", label: "Hisar", value: "Hisar", stateCode: "HR" },

  // Punjab (PB)
  { id: "PB_LUD", label: "Ludhiana", value: "Ludhiana", stateCode: "PB" },
  { id: "PB_AMR", label: "Amritsar", value: "Amritsar", stateCode: "PB" },
  { id: "PB_JAL", label: "Jalandhar", value: "Jalandhar", stateCode: "PB" },
  { id: "PB_PAT", label: "Patiala", value: "Patiala", stateCode: "PB" },
  { id: "PB_BAT", label: "Bathinda", value: "Bathinda", stateCode: "PB" },

  // Kerala (KL)
  { id: "KL_KOC", label: "Kochi", value: "Kochi", stateCode: "KL" },
  { id: "KL_THI", label: "Thiruvananthapuram", value: "Thiruvananthapuram", stateCode: "KL" },
  { id: "KL_KOZ", label: "Kozhikode", value: "Kozhikode", stateCode: "KL" },
  { id: "KL_THR", label: "Thrissur", value: "Thrissur", stateCode: "KL" },
  { id: "KL_KOL", label: "Kollam", value: "Kollam", stateCode: "KL" },

  // Andhra Pradesh (AP)
  { id: "AP_VIS", label: "Visakhapatnam", value: "Visakhapatnam", stateCode: "AP" },
  { id: "AP_VIJ", label: "Vijayawada", value: "Vijayawada", stateCode: "AP" },
  { id: "AP_GUN", label: "Guntur", value: "Guntur", stateCode: "AP" },
  { id: "AP_NEL", label: "Nellore", value: "Nellore", stateCode: "AP" },
  { id: "AP_KUR", label: "Kurnool", value: "Kurnool", stateCode: "AP" },

  // Telangana (TS)
  { id: "TS_HYD", label: "Hyderabad", value: "Hyderabad", stateCode: "TS" },
  { id: "TS_WAR", label: "Warangal", value: "Warangal", stateCode: "TS" },
  { id: "TS_NIZ", label: "Nizamabad", value: "Nizamabad", stateCode: "TS" },
  { id: "TS_KAR", label: "Karimnagar", value: "Karimnagar", stateCode: "TS" },

  // Madhya Pradesh (MP)
  { id: "MP_DEW", label: "Dewas", value: "Dewas", stateCode: "MP" }, // ✅ add this
  { id: "MP_BHO", label: "Bhopal", value: "Bhopal", stateCode: "MP" },
  { id: "MP_IND", label: "Indore", value: "Indore", stateCode: "MP" },
  { id: "MP_GWA", label: "Gwalior", value: "Gwalior", stateCode: "MP" },
  { id: "MP_JAB", label: "Jabalpur", value: "Jabalpur", stateCode: "MP" },
  { id: "MP_UJJ", label: "Ujjain", value: "Ujjain", stateCode: "MP" },

  // Bihar (BR)
  { id: "BR_PAT", label: "Patna", value: "Patna", stateCode: "BR" },
  { id: "BR_GAY", label: "Gaya", value: "Gaya", stateCode: "BR" },
  { id: "BR_BHA", label: "Bhagalpur", value: "Bhagalpur", stateCode: "BR" },
  { id: "BR_MUZ", label: "Muzaffarpur", value: "Muzaffarpur", stateCode: "BR" },

  // Odisha (OR)
  { id: "OR_BHU", label: "Bhubaneswar", value: "Bhubaneswar", stateCode: "OR" },
  { id: "OR_CUT", label: "Cuttack", value: "Cuttack", stateCode: "OR" },
  { id: "OR_ROU", label: "Rourkela", value: "Rourkela", stateCode: "OR" },

  // Assam (AS)
  { id: "AS_GUW", label: "Guwahati", value: "Guwahati", stateCode: "AS" },
  { id: "AS_DIB", label: "Dibrugarh", value: "Dibrugarh", stateCode: "AS" },
  { id: "AS_SIL", label: "Silchar", value: "Silchar", stateCode: "AS" },

  // Jharkhand (JH)
  { id: "JH_RAN", label: "Ranchi", value: "Ranchi", stateCode: "JH" },
  { id: "JH_JAM", label: "Jamshedpur", value: "Jamshedpur", stateCode: "JH" },
  { id: "JH_DHA", label: "Dhanbad", value: "Dhanbad", stateCode: "JH" },

  // Chhattisgarh (CT)
  { id: "CT_RAI", label: "Raipur", value: "Raipur", stateCode: "CT" },
  { id: "CT_BIL", label: "Bilaspur", value: "Bilaspur", stateCode: "CT" },

  // Uttarakhand (UK)
  { id: "UK_DEH", label: "Dehradun", value: "Dehradun", stateCode: "UK" },
  { id: "UK_HAR", label: "Haridwar", value: "Haridwar", stateCode: "UK" },

  // Himachal Pradesh (HP)
  { id: "HP_SHI", label: "Shimla", value: "Shimla", stateCode: "HP" },
  { id: "HP_DHA", label: "Dharamshala", value: "Dharamshala", stateCode: "HP" },

  // Jammu and Kashmir (JK)
  { id: "JK_SRI", label: "Srinagar", value: "Srinagar", stateCode: "JK" },
  { id: "JK_JAM", label: "Jammu", value: "Jammu", stateCode: "JK" },

  // Goa (GA)
  { id: "GA_PAN", label: "Panaji", value: "Panaji", stateCode: "GA" },
  { id: "GA_VAS", label: "Vasco da Gama", value: "Vasco da Gama", stateCode: "GA" },

  // Chandigarh (CH)
  { id: "CH_CHA", label: "Chandigarh", value: "Chandigarh", stateCode: "CH" },

  // Puducherry (PY)
  { id: "PY_PUD", label: "Puducherry", value: "Puducherry", stateCode: "PY" },
];

// Lookup object for efficient city filtering by state
export const CitiesByState: { [stateCode: string]: CityOption[] } = IndianCities.reduce((acc, city) => {
  if (!acc[city.stateCode]) {
    acc[city.stateCode] = [];
  }
  acc[city.stateCode].push(city);
  return acc;
}, {} as { [stateCode: string]: CityOption[] });

// Utility functions for city operations
export const getCitiesForState = (stateCode: string): CityOption[] => {
  return CitiesByState[stateCode] || [];
};

export const findCityByValue = (cityValue: string, stateCode?: string): CityOption | undefined => {
  if (stateCode) {
    return getCitiesForState(stateCode).find(city => city.value === cityValue);
  }
  return IndianCities.find(city => city.value === cityValue);
};

export const validateStateCity = (stateCode: string, cityValue: string): boolean => {
  const cities = getCitiesForState(stateCode);
  return cities.some(city => city.value === cityValue);
};

export const getStateCodeFromName = (stateName: string): string => {
  if (!stateName) return "";
  const match = IndianStates.find(
    (s) => s.label.toLowerCase().trim() === stateName.toLowerCase().trim()
  );
  return match ? match.value : "";
};